export const LINK_GUARDIAN_CONTACT_TO_ACCOUNT_REQUEST = 'newsletter/LINK_GUARDIAN_CONTACT_TO_ACCOUNT_REQUEST';
export const LINK_GUARDIAN_CONTACT_TO_ACCOUNT_SUCCESS = 'newsletter/LINK_GUARDIAN_CONTACT_TO_ACCOUNT_SUCCESS';
export const LINK_GUARDIAN_CONTACT_TO_ACCOUNT_FAILURE = 'newsletter/LINK_GUARDIAN_CONTACT_TO_ACCOUNT_FAILURE';

export const INIT_LINKED = 'newsletter/INIT_LINKED';

export const linkGuardianContactToAccountRequest = (payload = {}) => ({
  type: LINK_GUARDIAN_CONTACT_TO_ACCOUNT_REQUEST,
  payload,
});
export const linkGuardianContactToAccountSuccess = (payload = {}) => ({
  type: LINK_GUARDIAN_CONTACT_TO_ACCOUNT_SUCCESS,
  payload,
});
export const linkGuardianContactToAccountFailure = (payload = {}) => ({
  type: LINK_GUARDIAN_CONTACT_TO_ACCOUNT_FAILURE,
  payload,
});

export const initLinked = (payload = {}) => ({
  type: INIT_LINKED,
  payload,
});
